import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppCommonModule } from '@app/modules/common/common.module';
import { CompanyFormsModule } from '@app/modules/forms/company/company-forms.module';
import { DocumentsFormsModule } from '@app/modules/forms/documents/documents-forms.module';
import { EmployeeFormsModule } from '@app/modules/forms/employees/employee-forms.module';
import { PlatformModule } from '@app/platform.module';
import { CandidateForms } from './candidate/components';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        AppCommonModule,
        PlatformModule,
        CompanyFormsModule,
        EmployeeFormsModule,
        DocumentsFormsModule,
    ],
    declarations: [...CandidateForms],
    exports: [...CandidateForms],
})
export class CandidateFormsModule {}
